import { LoadingSpinnerIcon } from '@mgmresorts/wcl-lab';
import React from 'react';

export default function AuthPartnerLinkPage() {
  // If the user lands here, then they should already be logged in.
  // The Auth Provider will identify the logged in user, link their account, and then redirect them out.
  return <LoadingSpinnerIcon size='48' testId='route-/auth/partner-link' />;
}
